export default {
  'quotation.form.reportType': 'Select the Report Type',
  'quotation.form.reportType.itemsSuppliers': 'Items/Suppliers',
  'quotation.form.reportType.suppliersItems': 'Suppliers/Items',
  'quotation.form.reportType.lowestPrice': 'Lowest Price',
  'quotation.form.reportType.vehicleQuotation': 'Vehicle/Quotation',
  'quotation.form.reportType.OSQuotation': 'OS/Quotation',

  'quotation.form.orderBy': 'Order By',
  'quotation.form.orderBy.items': 'Items',
  'quotation.form.orderBy.suppliers': 'Suppliers',

  'quotation.moreOptions': 'More Options',
  'quotation.moreOptions.button.selectSupplier': 'Select Supplier',
  'quotation.moreOptions.button.selectVehicle': 'Select Vehicle',
};
